import {selectRecentPlayedGames} from '../../store/reducers';

import React from 'react';
import {useSelector} from 'react-redux';
import ScrollContainer from 'react-indiana-drag-scroll';
import RecentGameItem from './RecentGameItem';
import styled, {css} from 'styled-components';
import {breakpoints, mobileMediaQuery, notWebMediaQuery} from '../../styles';
import {useTranslation} from 'react-i18next';
import {useBrand} from '../../helpers';

const GameRecentView = ({allGames, width, handleClickGame, className}) => {
    const recentGames = useSelector(state =>
        selectRecentPlayedGames(state, allGames || []),
    );
    const {t} = useTranslation();
    const brand = useBrand();

    let itemWidth = 674; //desktop size
    let gutter = 16;
    let margin = 40;
    let count = recentGames?.length || 0;
    if (width < breakpoints.mobile) {
        gutter = 8;
        margin = 25;
        itemWidth = width - margin * 2;
    } else if (width < breakpoints.md) {
        itemWidth = Math.max((width - margin * 2 - gutter) / 2, 453);
    } else {
        //use the remaining space
        itemWidth = (width - margin * 2 - gutter * (count - 1)) / count;
    }

    if (recentGames && recentGames.length > 1) {
        return (
            <Container className={className}>
                <Title brand={brand}>{t('games.recents')}</Title>
                <ScrollContainer horizontal={true} className="scroll-container">
                    <HStack width={count * (itemWidth + gutter) - gutter}>
                        {recentGames.map((game, index) => {
                            return (
                                <RecentGameItem
                                    game={game}
                                    key={index}
                                    width={itemWidth}
                                    gutter={gutter}
                                    handleClickGame={handleClickGame}
                                    brand={brand}
                                />
                            );
                        })}
                    </HStack>
                </ScrollContainer>
            </Container>
        );
    }
    return null;
};

const Container = styled.div`
    ${notWebMediaQuery} {
        width: 100%;
    }
`;

const HStack = styled.div`
    display: flex;
    flex-direction: row;
    width: ${props => props.width}px;

    padding: 0px 40px;

    ${mobileMediaQuery} {
        padding: 0px 25px;
    }
`;

const Title = styled.div`
    padding: 0px 40px;
    font-family: TTNormsProExtraBlack;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 26px;
    text-transform: uppercase;
    margin: 16px 0px;

    ${mobileMediaQuery} {
        padding: 0px 25px;
    }

    ${props =>
        props.brand === 'dkids' &&
        css`
            font-family: Mont;
            font-weight: 900;
        `}
`;

export default GameRecentView;
